export default __webpack_public_path__ + "static/media/sanoh.e3ef2d49.png";